import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../api/http';
import './global.css';

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: '', name: '', password: '', role: 'user' });
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const data = await apiGet('/api/users');
      setUsers(data);
    } catch (err) {
      console.error(err);
      alert('Failed to load users');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUser) {
        // Prevent editing lpadmin
        if (editingUser.email === 'lpadmin@softdof.com') {
          alert('This account is locked and cannot be modified.');
          return;
        }
        await apiPut(`/api/users/${editingUser.id}`, form);
        setEditingUser(null);
      } else {
        await apiPost('/api/users', form);
      }
      setForm({ email: '', name: '', password: '', role: 'user' });
      loadUsers();
    } catch (err) {
      console.error(err);
      alert('Failed to save user');
    }
  };

  const handleEdit = (u) => {
    if (u.email === 'lpadmin@softdof.com') {
      alert('This account is locked and cannot be edited.');
      return;
    }
    setEditingUser(u);
    setForm({ email: u.email, name: u.name, password: '', role: u.role });
  };

  const handleDeactivate = async (id, email) => {
    if (email === 'lpadmin@softdof.com') {
      alert('This account is locked and cannot be deactivated.');
      return;
    }
    if (!window.confirm('Deactivate this user?')) return;
    await apiDelete(`/api/users/${id}`);
    loadUsers();
  };


  const handleActivate = async (id, email) => {
    if (email === 'lpadmin@softdof.com') {
      alert('This account is locked and cannot be activated here.');
      return;
    }
    if (!window.confirm('Activate this user?')) return;
    await apiPut(`/api/users/${id}`, { is_active: true });
    loadUsers();
  };

  return (
    <div className="card users-list">
      <h2>User Management</h2>

      <form onSubmit={handleSubmit} style={{ marginBottom: '2em' }}>
        <h3>{editingUser ? 'Edit User' : 'Create New User'}</h3>

        <div className="form-grid">
          <div>
            <label>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              disabled={editingUser?.email === 'lpadmin@softdof.com'}
            />
          </div>
          <div>
            <label>Name</label>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              disabled={editingUser?.email === 'lpadmin@softdof.com'}
            />
          </div>
          <div>
            <label>Password</label>
            <input
              type="password"
              value={form.password}
              placeholder={editingUser ? 'Leave blank to keep current' : ''}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required={!editingUser}
              disabled={editingUser?.email === 'lpadmin@softdof.com'}
            />
          </div>
          <div>
            <label>Role</label>
            <select
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
              disabled={editingUser?.email === 'lpadmin@softdof.com'}
            >
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="superadmin">Super Admin</option>
            </select>
          </div>
        </div>

        <div style={{ marginTop: '1em' }}>
          <button
            className="btn primary"
            type="submit"
            disabled={editingUser?.email === 'lpadmin@softdof.com'}
          >
            {editingUser ? 'Update' : 'Create'}
          </button>
          {editingUser && (
            <button
              type="button"
              className="btn secondary"
              style={{ marginLeft: '0.5em' }}
              onClick={() => {
                setEditingUser(null);
                setForm({ email: '', name: '', password: '', role: 'user' });
              }}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      <table className="styled-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Name</th>
            <th>Role</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="6" className="empty-state">
                No users found
              </td>
            </tr>
          ) : (
            users.map((u) => (
              <tr key={u.id}>
                <td data-label="Email">{u.email}</td>
                <td data-label="Name">{u.name}</td>
                <td data-label="Role">{u.role}</td>
                <td data-label="Status">{u.is_active ? 'Active' : 'Inactive'}</td>
                <td data-label="Created">
                  {new Date(u.created_at).toLocaleString()}
                </td>
                <td data-label="Actions">
                  {u.email === 'lpadmin@softdof.com' ? (
                    <span style={{ color: '#999', fontSize: '0.9em' }}>Locked</span>
                  ) : (
                    <>
                      {u.is_active ? (
                        <button
                          className="btn secondary small"
                          onClick={() => handleEdit(u)}
                        >
                          Edit
                        </button>
                      ) : null}{' '}
                      {u.is_active ? (
                        <button
                          className="btn danger small"
                          onClick={() => handleDeactivate(u.id, u.email)}
                        >
                          Deactivate
                        </button>
                      ) : (
                        <button
                          className="btn primary small"
                          onClick={() => handleActivate(u.id, u.email)}
                        >
                          Activate
                        </button>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
